/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Withdrawal_1Inputs */

const da_terms_withdrawal_1 = /** @type {(inputs: Terms_Withdrawal_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Køber du som forbruger, har du 14 dages fortrydelsesret fra købet. Beder du os om at levere tjenesten med det samme, skal du betale for den del, du har brugt, hvis du fortryder. Fortrydelsesretten gælder ikke køb foretaget af virksomheder, skoler og kommuner.`)
};

/** @type {(inputs: Terms_Withdrawal_1Inputs) => LocalizedString} */
const en_terms_withdrawal_1 = da_terms_withdrawal_1;

/**

* @param {Terms_Withdrawal_1Inputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const terms_withdrawal_1 = /** @type {((inputs?: Terms_Withdrawal_1Inputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Withdrawal_1Inputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_terms_withdrawal_1(inputs)
	return /** @type {LocalizedString} */ ("Køber du som forbruger, har du 14 dages fortrydelsesret fra købet. Beder du os om at levere tjenesten med det samme, skal du betale for den del, du har brugt, hvis du fortryder. Fortrydelsesretten gælder ikke køb foretaget af virksomheder, skoler og kommuner.")
});